export default __webpack_public_path__ + "static/media/640_dummy2016-lebenslaufbusiness01-mobile.4c30fa5e.png";